module.exports = __webpack_public_path__ + "static/media/mainBackground.bc740630.png";